var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.validAsset)?_c('div',{staticClass:"w-full h-full bg-scene-gray"},[_c('PrevizViewerContainer',{attrs:{"id":_vm.asset.id,"container-id":_vm.containerId,"mode":"scene","supress-controls":!_vm.playMode}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }